<template>
	<div class="step-picker-v2 p-5">
		<div class="step-picker-header">
			<h5 class="step-picker-title">{{ title }}</h5>
			<div class="step-picker-controls">
				<button class="step-picker-ctrl-btn" @click="expandAll" title="Tout déplier">
					<i class="fas fa-chevron-down mr-1"></i> Tout déplier
				</button>
				<button class="step-picker-ctrl-btn" @click="collapseAll" title="Tout replier">
					<i class="fas fa-chevron-up mr-1"></i> Tout replier
				</button>
			<button class="step-picker-ctrl-btn step-picker-legacy-btn" v-if="!simple_mode" @click="showLegacyModal = true" title="Étapes legacy">
					<i class="fas fa-plus"></i>
				</button>
			</div>
		</div>
		<div
			v-for="theme in themes"
			:key="theme.label"
			class="step-picker-section">
			<div class="step-picker-theme-title" @click="toggle(theme.label)">
				<i :class="theme.icon" class="mr-1"></i>
				{{ theme.label }}
				<i :class="isOpen(theme.label) ? 'fas fa-chevron-up' : 'fas fa-chevron-down'" class="step-picker-chevron"></i>
			</div>
			<div v-show="isOpen(theme.label)" class="step-picker-row">
				<div
					v-for="action in theme.actions"
					:key="action.value"
					class="step-picker-card"
					:title="action.description || ''"
					@click="$emit('select', action)">
					{{ action.label }}
				</div>
			</div>
		</div>

		<b-modal v-model="showLegacyModal" title="Étapes legacy" hide-footer size="lg">
			<div class="step-picker-legacy-row">
				<div
					v-for="action in legacyActions"
					:key="action.value"
					class="step-picker-card"
					@click="selectLegacy(action)">
					{{ action.label }}
				</div>
			</div>
		</b-modal>
	</div>
</template>

<script>
	import { ActionListV2, ActionList } from "../utils/liste_actions.js";

	export default {
		name: "StepPickerV2",
		props: {
			title: { type: String, default: "Choisir une étape" },
			simple_mode: { type: Boolean, default: false },
			excluded_actions: { type: Array, default: () => [] },
		},
		data() {
			return {
				openSections: {},
				showLegacyModal: false,
			};
		},
		computed: {
			themes() {
				const excluded = new Set(this.excluded_actions);
				if (excluded.size === 0) return ActionListV2();
				return ActionListV2()
					.map(theme => ({
						...theme,
						actions: theme.actions.filter(a => !excluded.has(a.value)),
					}))
					.filter(theme => theme.actions.length > 0);
			},
			legacyActions() {
				const v2Values = new Set(ActionListV2().flatMap(t => t.actions.map(a => a.value)));
				const all = ActionList().flatMap(group => group.options || []);
				const seen = new Set();
				return all
					.filter(a => !v2Values.has(a.value) && !seen.has(a.value) && seen.add(a.value))
					.sort((a, b) => a.label.localeCompare(b.label, 'fr', { sensitivity: 'base' }));
			},
		},
		methods: {
			isOpen(label) {
				return this.openSections[label] === true;
			},
			toggle(label) {
				this.$set(this.openSections, label, !this.isOpen(label));
			},
			expandAll() {
				this.themes.forEach(t => this.$set(this.openSections, t.label, true));
			},
			collapseAll() {
				this.themes.forEach(t => this.$set(this.openSections, t.label, false));
			},
			selectLegacy(action) {
				this.showLegacyModal = false;
				this.$emit('select', action);
			},
		},
	};
</script>

<style scoped>
.step-picker-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 16px;
}
.step-picker-title {
	font-size: 1.1rem;
	font-weight: 700;
	margin: 0;
	color: #374151;
}
.step-picker-controls {
	display: flex;
	gap: 6px;
}
.step-picker-ctrl-btn {
	font-size: 0.75rem;
	padding: 3px 10px;
	border: 1px solid #d1d5db;
	border-radius: 5px;
	background: #f9fafb;
	color: #6b7280;
	cursor: pointer;
	transition: background 0.15s, color 0.15s;
}
.step-picker-ctrl-btn:hover {
	background: #e5e7eb;
	color: #374151;
}
.step-picker-legacy-btn {
	border-color: #c7d2fe;
	color: #6366f1;
}
.step-picker-legacy-btn:hover {
	background: #eef2ff;
	border-color: #6366f1;
	color: #4338ca;
}
.step-picker-v2 {
	width: 100%;
}
.step-picker-section {
	margin-bottom: 16px;
}
.step-picker-theme-title {
	font-size: 0.72rem;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.07em;
	color: #9ca3af;
	margin-bottom: 8px;
	cursor: pointer;
	display: flex;
	align-items: center;
	gap: 6px;
	user-select: none;
}
.step-picker-theme-title:hover {
	color: #6366f1;
}
.step-picker-chevron {
	margin-left: auto;
	font-size: 0.65rem;
}
.step-picker-row {
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
	padding-bottom: 10px;
}
.step-picker-legacy-row {
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
	padding: 4px 0 8px;
}
.step-picker-card {
	background: #fff;
	border: 1px solid #e5e7eb;
	border-radius: 6px;
	padding: 8px 14px;
	font-size: 0.92rem;
	cursor: pointer;
	white-space: nowrap;
	transition: border-color 0.15s, background 0.15s, color 0.15s;
}
.step-picker-card:hover {
	border-color: #6366f1;
	background: #eef2ff;
	color: #4338ca;
}
</style>
